import { setContext } from '@apollo/client/link/context'

import { getAdditionalHeaders } from '@/network/common/additionalHeaders'
import { getCookie, getUserIdFromAuthToken } from '@/providers/authentication/authentication.helpers'

/**
 * @private only to be used in apolloClient.ts
 */
export const authLink = setContext(async ({ operationName }, { headers }) => {
  const additionalHeaders = await getAdditionalHeaders()

  const token = getCookie('token')

  const userId = getUserIdFromAuthToken()

  const shouldSendAuthorization = operationName
    ? !['LoginWithImpersonationToken', 'LoginWithMagicToken'].includes(operationName)
    : false

  const authorization = shouldSendAuthorization && token ? { authorization: token } : {}

  return {
    headers: {
      ...headers,
      ...additionalHeaders,
      ...authorization,
      'x-voggt-user-id': userId,
    },
  }
})
